


window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.eventNamespace
      ? 'focusin.' + options.eventNamespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/*================ SLEEPLESS ================*/
var productVariants = (function() {
	var productSelect = $("#product-variants-select"),
		variants = productSelect.children('option'),
		priceField = document.getElementById('price-field'),
		availableVariants = [],
		optionSelects = $(".option-wrapper-select"),
		submitBtn = $("#product-submit");

	if(optionSelects.length) optionSelects.change(updateVariants);

	if(productSelect.length) {
		//loop through hidden variants and turn them into usable objects
		for(var i=0;i<variants.length;i++) {
			var newVariant = {"options": variants[i].getAttribute('data-options').split(","), "id": variants[i].getAttribute('value'), "price": variants[i].getAttribute('data-price')}
			availableVariants.push(newVariant);
		}
		if(optionSelects.length) updateVariants();
		if(variants.length == 0) {
			setSubmitButton(true);
		}
	}

	function updateVariants() {
		var currentOptions = getCurrentOptions(),
			matchedVariant = null,
			inStock = false;
		//loop through all variants
		for(var i=0;i<availableVariants.length;i++) {
			var variantOptions = availableVariants[i].options,
				count = 0;
			//loop through options for current variant
			for(var j=0;j<variantOptions.length;j++) {
				//loop through selected options and check if they match with variantOptions
				var selectedOptions = currentOptions;
				for(var k=0;k<currentOptions.length;k++) {
					if(variantOptions[j] === selectedOptions[k]) {
						count++;
					}
				}
			}
			//if count equals options length that means the variant is available
			if(count === variantOptions.length) {
				inStock = true;
				matchedVariant = availableVariants[i];
				priceField.innerHTML = matchedVariant.price;
				break;
			}
		}
		if(inStock) {
			//change selected variant in official product select
			for(var i=0;i<variants.length;i++) {
				if(variants[i].getAttribute('value') === matchedVariant.id) {
					variants[i].setAttribute('selected', 'selected');
				} else variants[i].removeAttribute('selected');
			}
			setSubmitButton(false);
		} else {
			setSubmitButton(true);
		}
	}

	function setSubmitButton(disable) {
		if(disable) {
			submitBtn.attr('disabled', 'disabled');
			submitBtn.children('span').text('SOLD OUT');
		} else {
			submitBtn.removeAttr('disabled');
			submitBtn.children('span').text('ADD TO CART');
		}
	}

	function getCurrentOptions() {
		//get array of currently selected options
		var options = [];
		for(var i=0;i<optionSelects.length;i++) {
			options.push(optionSelects[i].value);
		}
		return options;
	}
})();
var productImages = (function() {
	var smallImages = $(".product-small-pic-container .small-image"),
		bigImages = $("#product-pic-container .big-image");

	smallImages.click(changeImage);

	function changeImage() {
		var smallId = $(this).attr('data-id'),
			activePic = null,
			nextPic = null;

		//find active image and next image
		for(var i=0;i<bigImages.length;i++) {
			if(bigImages[i].getAttribute('data-id') === smallId) {
				nextPic = bigImages[i];
			}
			if(bigImages[i].getAttribute('data-active') === 'true') {
				activePic = bigImages[i];
			}
		}

		activePic = $(activePic);
		nextPic = $(nextPic);

		activePic.hide().attr('data-active', 'false').children('img').removeClass('active');
		nextPic.show().attr('data-active', 'true').children('img').addClass('active');
	}

})();

var quantityChange = (function() {
	var numberChange = $(".number-change");

	numberChange.click(function() {
		var parent = $(this).parents(".product-options"),
			displayValue = parent.find('.quantity-selector .number'),
			input = parent.find('input[name="quantity"]'),
			inputVal = parseInt(input.val()),
			newVal = inputVal;
		
		if(parent.length === 0) {
			parent = $(this).parents('.number-cell');
			displayValue = parent.find('.quantity-selector .number');
			input = parent.find('input');
			inputVal = parseInt(input.val());
			newVal = inputVal;
		}

		if($(this).hasClass('plus')) {
			newVal = inputVal + 1;
		} else {
			if((inputVal - 1) <= 0) {
				newVal = 0;
			} else {
				newVal = inputVal - 1;
			}
		}
		input.val(newVal);
		displayValue.text(newVal);
	});
})();

var productAccordion = (function() {
	var accTitles = $("#product-accordion .item .accordion-title");

	accTitles.click(function() {
		if($(this).next().css('display') === 'block') {
			accTitles.next().slideUp(250);
			accTitles.children('.collapse-icon').text('+');
		} else {
			accTitles.next().slideUp(250);
			accTitles.children('.collapse-icon').text('+');
			$(this).next().stop().slideDown(250);
			$(this).children('.collapse-icon').text('-');
		}
	});
})();
var navbarClick = (function() {
	var navSearch = $("#nav-search"),
		navForm = $(navSearch.find('.input-div')),
		navInput = $('#nav-input');

	navInput.blur(function() {
		navForm.stop().removeClass('active');
	});

	navSearch.hover(function() {
		navForm.addClass('active');
		navInput.focus();
	}, function() {
		if(!navInput.is(':focus')) {
			navForm.stop().removeClass('active');
		}
	});
})();

var flyout = (function() {
	var flyoutButtons = $(".flyout-button"),
		site = $(".entire-site"),
		body = $("body"),
		flyout = $("#flyout");

	flyoutButtons.click(activateFlyout);

	function activateFlyout() {
		if($(window).width() <= 991 || flyout.hasClass('active')) {
			if(flyout.hasClass('active')) {
				flyout.removeClass('active');
				site.removeClass('active');
				body.removeClass('no-scroll');
			} else {
				flyout.addClass('active');
				site.addClass('active');
				body.addClass('no-scroll');
			}
		}
	}
})();

var navScroll = (function() {
	var mainNav = $("#navbar"),
		$window = $(window),
		backToTop = $("#document-to-top"),
		propNav = $("#prop-navbar");

	$window.scroll(navPosition);
	backToTop.click(function() {
		$('html, body').animate({
			scrollTop:0
		}, 450);
	});

	function navPosition() {
		var winScroll = $window.scrollTop(),
			navFixed = mainNav.attr('data-fixed'),
			snapBackPos = 0;

		//navbar check
		if(!mainNav.hasClass('homepage-hide') || $window.width() <= 991) {
			if(winScroll > 500 && navFixed === "false") {
				switchNavPosition(true);
			} else if(winScroll <= snapBackPos && navFixed === "true") {
				switchNavPosition(false);
			}
		}

		//back to top button
		if(winScroll > 500) {
			backToTop.fadeIn(200);
		} else {
			backToTop.fadeOut(200);
		}
	}

	function switchNavPosition(fixed) {
		if(fixed) {
			propNav.show();
			mainNav.addClass('fixed');
			mainNav.attr('data-fixed', 'true');
			mainNav.animate({
				top: '0px'
			}, 200);
		} else {
			propNav.hide();
			mainNav.removeClass('fixed');
			mainNav.removeAttr('style');
			mainNav.attr('data-fixed', 'false');
		}
	}
})();
var themeDropdowns = (function() {
	var dropContainer = $(".nav-dropdown-container");

	dropContainer.hover(function() {
		var dropdown = $(this).find('.nav-dropdown');
		dropdown.fadeIn(175);
		dropdown.addClass('active');
	}, function() {
		var dropdown = $(this).find('.nav-dropdown');
		dropdown.fadeOut(175);
		dropdown.removeClass('active');
	});
})();
var addToCart = (function() {
	var productForm = $("#product-form"),
		submitSpan = $(".product-submit-span"),
		cartIcon = $("#cart-icon");

	if($(window).width() >= 800) {
		productForm.attr('action', '#');
		productForm.submit(addItem);
	}

	function addItem(e) {
		e.preventDefault();
		submitSpan.text("ADDING");
		$.post('/cart/add.js', productForm.serialize(), function(resp) {
			getCart.activate(null, true);
			submitSpan.text("ADDED!");
			setTimeout(function() {
				submitSpan.text("ADD TO CART");
			}, 1500);
		}, 'json');
	}
})();

var getCart = (function() {
	var ajaxCart = $("#ajax-cart"),
		cartAmounts = $(".cart-amount"),
		cartIconAmount = $(".cart-icon-amount"),
		cartTotal = $("#ajax-cart #cart-total"),
		cartLinks = $(".cart-link"),
		overlay = $("#cart-overlay"),
		cartItemTemplate = $("#cart-item-template").html(),
		itemsEntry = $("#ajax-cart .items-entry");

	//change default tags since they are the same as liquid
	var customTags = ['<%', '%>'];
	Mustache.parse(cartItemTemplate, customTags);
	Mustache.tags = customTags;

	//disable cart icon link if javascript enabled
	if($(window).width() >= 800) {
		cartLinks.attr('href', 'javascript:;');
		cartLinks.click(activateCart);
		ajaxCart.click(function(e) { e.stopPropagation(); });
		ajaxCart.on("click", ".remove-item", removeCartItem);
		overlay.click(activateCart);
	}

	function activateCart(e, fetchCart) {
		if(e) e.stopPropagation();
		if($(window).width() < 700) {
			window.location.href = "/cart";
		} else {
			if(ajaxCart.attr('data-active') === "true") {
				ajaxCart.fadeOut(175);
				ajaxCart.removeClass('active');
			} else {
				ajaxCart.fadeIn(175);
				ajaxCart.addClass('active');
				if(fetchCart) {
					getCart();
				}
			}
		}
	}

	function getCart() {
		ajaxCart.addClass('loading');
		itemsEntry.html('');
		//get cart from shopify
		$.get('/cart.js', function(resp) {
			ajaxCart.removeClass('loading');
			if(resp.items.length > 0) {
				var newItems = document.createDocumentFragment();
				for(var i=0;i<resp.items.length;i++) {
					//create new element, add to doc frag
					newItems.appendChild(createCartElement(resp.items[i], i));
				}
				//append frag to cart
				itemsEntry.html(newItems);
				updateCartInfo(resp.items.length, "$" + ((resp.total_price/100).toFixed(2)))
			} else {
				updateCartInfo(0)
			}
		}, 'json');

		function createCartElement(item, index) {
			//create new element
			var div = document.createElement('div');
			div.setAttribute('class', 'cart-item');

			//render mustache template with prepped item
			prepItemObject();
			div.innerHTML = Mustache.render(cartItemTemplate, item);

			return div;

			function prepItemObject() {
				item.displayPrice = (item.price/100).toFixed(2);
				item.line_number = index + 1;
			}
		}
	}

	function updateCartInfo(itemAmount, totalPrice) {
		if(itemAmount) {
			cartAmounts.text(itemAmount);
			cartIconAmount.show();
		} else {
			cartAmounts.text('0');
			itemsEntry.html('<div class="no-items"><p>You have no items in your shopping cart</p></div>');
			cartTotal.text('$0.00');
			cartIconAmount.hide();
		}
		if(totalPrice) cartTotal.text(totalPrice);
	}

	function removeCartItem() {
		var itemId = $(this).attr('data-id'),
			cartItem = $(this).parents('.cart-item');

		$.post('/cart/change.js', {quantity:0, id: itemId}, function() {
			cartItem.fadeOut(200);
			$.get('/cart.js', function(resp) {
				updateCartInfo(resp.items.length, "$" + ((resp.total_price/100).toFixed(2)));
			}, 'json');
		}, 'json');
	}

	getCart();

	return {
		activate: activateCart
	}
})();
var homeHero = (function() {
	var backgrounds = $(".hero-background-item");

	function switchBackground() {
		var activeBackground = null,
			activeIndex = 0;
		for(var i=0;i<backgrounds.length;i++) {
			if(backgrounds[i].getAttribute('data-active') === 'true') {
				activeIndex = i;
				backgrounds[i].setAttribute('data-active', 'false');
				activeBackground = $(backgrounds[i]);
			}
		}
		if(activeIndex + 1 >= backgrounds.length) {
			activeIndex = 0;
		} else activeIndex += 1;

		activeBackground.fadeOut(1000);
		$(backgrounds[activeIndex]).fadeIn(1000).attr('data-active', 'true');
		setTimeout(function() {
			switchBackground();
		}, 5000);
	}

	if(backgrounds.length) {
		setTimeout(function() {
			switchBackground();
		}, 5000);
	}
})();

var homeVideo = (function() {
	var video = document.querySelector('#home-video video'),
		homeVideo = $(".home-video"),
		playButton = homeVideo.find('.play-button');

	homeVideo.click(function() {
		$(".placeholder-background").hide();
		if(video.paused) {
			video.play();
			playButton.hide();
		} else {
			video.pause();
			playButton.show();
		}
	});
})();
var interiorAccordions = (function() {
	var accTitles = $(".default-accordion .title");

	accTitles.click(function() {
		var parent = $(this).parents('.default-accordion');
		if($(this).next().css('display') === 'block') {
			parent.find('.content').slideUp(200);
			parent.find('.title').removeClass('active');
		} else {
			parent.find('.content').slideUp(200);
			parent.find('.title').removeClass('active');
			$(this).next().stop().slideDown(200);
			$(this).addClass('active');
		}
	});
})();
//forgot password form
var forgotPassword = (function() {
	var forgotBtn = $("#forgot-password"),
		loginForm = $("#login-form"),
		forgotForm = $("#forgot-password-form"),
		sentEmail = $("#successful-post");

	if(forgotBtn.length) forgotBtn.click(function() {
		loginForm.hide();
		forgotForm.show();
		$("#login-header").text('RECOVER PASSWORD');
	});

	if(sentEmail.length) $("#form-reset-success").html("<p><em>Reset Password Email Sent!</em></p>");
})();

var switchForm = (function() {
	var formSwitch = $(".form-switch"),
		formUpdates = $(".form-updates"),
		form = $("#forgot-password-form");

	formSwitch.click(function() {
		$("#login-register .form-div").fadeOut(150);
		if($(this).hasClass('login')) {
			form = $("#login-form");
		} else if($(this).hasClass('signup')) {
			form = $("#signup-form");
		} else {
			form = $("#forgot-password-form");
		}
		setTimeout(function() {
			form.fadeIn(150);
		}, 150)
	});

	var errors = $(".form-errors");
	for(var i=0;i<errors.length;i++) {
		var error = $(errors[i]);
		if(error.length) {
			$("#login-register .form-div").fadeOut(150);
			setTimeout(function() {
				if(/login/i.test(error.html())) {
					$("#login-form").fadeIn(150);
				}  else {
					$("#forgot-password-form").fadeIn(150);
				}
				formUpdates.html(error.html()).show();
				console.log(formUpdates)
			}, 150);
			break;
		}
	}
	if($("#successful-post").length) { formUpdates.html("Email sent!").show(); }
})();

//open/closing add/edit addresses
var accountPage = (function() {
	var addBtn = $("#add-address"),
		cancelBtn = $("#cancel-address-form"),
		addressForm = $("#address-form"),
		addressErrors = $("#address-form-errors"),
		editAddressBtn = $(".edit-address-link"),
		cancelEditBtn = $(".cancel-edit-address");

	if(editAddressBtn.length) editAddressBtn.click(editAddress);
	if(addressErrors.length) addressForm.slideDown();

	if(cancelBtn.length) cancelBtn.click(function() {
		addressForm.slideUp();
	});

	if(addBtn.length) addBtn.click(function() {
		addressForm.slideDown();
	});

	if(cancelEditBtn.length) cancelEditBtn.click(function() {
		$(this).parents('.edit-address').slideUp();
	});

	function editAddress() {
		$(this).parents('.customer-address').find('.edit-address').slideDown();
	}
})();	
var articleShareIcons = (function() {
	var links = $("#article-page .social-icons a");
	for(var i=0;i<links.length;i++) {
		var thisLink = $(links[i]),
			shareUrl = "";
		if(thisLink.attr('data-type') === "facebook") {
			shareUrl = 'https://twitter.com/share?url=' + window.location.href;
		} else if(thisLink.attr('data-type') === "twitter") {
			shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + window.location.href;
		} 
		if(shareUrl !== "") thisLink.attr('href', shareUrl);
	}

})();

$(document).ready(function() {
  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });
});

$(window).on('load', function() {
	$("#page-loading-screen").fadeOut(200);
	$(".pace").hide();
});
$(".DevST_first_level").click( function(e){
  e.preventDefault();
  $( this ).next(".DevST_sublinks").slideToggle();
});
/*$(".DevST_second_level").click( function(e){
  e.preventDefault();
  $( this ).next(".DevST_subsublinks").slideToggle();
});*/



